declare type PathEnabled = 'Session' | 'CreateSharedCookie' | 'TransferToB2C' | 'Account';

export const PathAccountManager: Record<PathEnabled, PathEnabled> = {
  Session: 'Session',
  CreateSharedCookie: 'CreateSharedCookie',
  TransferToB2C: 'TransferToB2C',
  Account: 'Account'
};
